// export const analytic = (type,data) =>{
//     window.dataLayer = window.dataLayer || [];
//     // window.dataLayer.push({
//     //     'event': type,
//     //     ...(type == 'send_message') && {'bot_name': data.bot_name},
//     //     ...(type == 'share_event') && {'share_type': data.share_type},
//     //     ...(type == 'app_invokation') && {'parent_domain': data.parent_domain},
//     // })

//     if(window?.gtag instanceof Function){
//         window?.gtag('event', type, {
//             ...(type == 'send_message') && {'bot_name': data.bot_name},
//             ...(type == 'share_event') && {'share_type': data.share_type},
//             ...(type == 'app_invokation') && {'parent_domain': data.parent_domain},
//             ...(type == 'change_language') && {'language': data.language},
//             ...(type == 'report_message') && {'reason': data.reason, 'message': data.message},
//         })
//     }

// }

import ReactGA from "react-ga4";

export const analytic = (type, data = {}) => {
    console.log("======== EVENT TRIGGERED ========");
    console.log("type", type);
    console.log("data", data);
    console.log("======== EVENT TRIGGERED ========");
    
    // Prepare event data
    const eventData = {
        ...(type === "send_message" && { bot_name: data.bot_name }),
        ...(type === "share_event" && { share_type: data.share_type }),
        ...(type === "app_invokation" && { parent_domain: data.parent_domain }),
        ...(type === "change_language" && { language: data.language }),
        ...(type === "report_message" && {
            reason: data.reason,
            message: data.message,
        }),
        ...(type === "response_time" && data)
    };

    // Send ReactGA event
    if(!window?.parentDomain || window?.parentDomain?.includes('creator')){
        ReactGA.event(type, eventData);
    }

    if (window?.parent && window?.parent !== window && document?.referrer?.includes(window?.parentDomain)) {
        try {
            window.parent.postMessage({
                type: 'analytics_event',
                eventName: type,
                eventData: eventData
            }, '*');
        } catch (error) {
            console.error('Error posting analytics message to parent:', error);
        }
    }
};